import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  TextField,
  IconButton,
  CircularProgress,
  useMediaQuery,
  useTheme,
  Toolbar,
  InputAdornment
} from "@mui/material";
import {
  Search as SearchIcon,
  ArrowBack as ArrowBackIcon
} from "@mui/icons-material";
import axios from "axios";

const UserPostRecovery = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const [postRecoveries, setPostRecoveries] = useState([]);
  const [filteredPostRecoveries, setFilteredPostRecoveries] = useState([]);
  const [selectedPostRecovery, setSelectedPostRecovery] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchPostRecoveries();
  }, []);

  const fetchPostRecoveries = async () => {
    try {
      const response = await axios.get("https://therapy-api.accentrixcloud.com/user-post-recovery");
      setPostRecoveries(response.data);
      setFilteredPostRecoveries(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch post recoveries", error);
      setLoading(false);
    }
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    setFilteredPostRecoveries(
      postRecoveries.filter(postRecovery =>
        postRecovery.provider.toLowerCase().includes(value) ||
        postRecovery.status.toLowerCase().includes(value) ||
        postRecovery.details.toLowerCase().includes(value)
      )
    );
  };

  const handleRowClick = (postRecovery) => {
    setSelectedPostRecovery(postRecovery);
  };

  const handleBackClick = () => {
    setSelectedPostRecovery(null);
  };

  const renderTable = () => (
    <TableContainer component={Paper}>
      <Table size={isMobile ? "small" : "medium"}>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Provider</TableCell>
            <TableCell>Duration</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredPostRecoveries.length > 0 ? (
            filteredPostRecoveries.map((postRecovery) => (
              <TableRow key={postRecovery.id} onClick={() => handleRowClick(postRecovery)}>
                <TableCell>{new Date(postRecovery.date).toLocaleDateString()}</TableCell>
                <TableCell>{postRecovery.provider}</TableCell>
                <TableCell>{postRecovery.duration}</TableCell>
                <TableCell>{postRecovery.status}</TableCell>
                <TableCell>
                  <Button variant="outlined" onClick={() => handleRowClick(postRecovery)}>
                    View Details
                  </Button>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5} align="center">
                No post-recovery records available.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderDetails = () => (
    <Box>
      <IconButton onClick={handleBackClick}>
        <ArrowBackIcon />
      </IconButton>
      <Typography variant="h6">Post-Recovery Details</Typography>
      <Typography variant="body1"><strong>Date:</strong> {new Date(selectedPostRecovery.date).toLocaleDateString()}</Typography>
      <Typography variant="body1"><strong>Provider:</strong> {selectedPostRecovery.provider}</Typography>
      <Typography variant="body1"><strong>Duration:</strong> {selectedPostRecovery.duration}</Typography>
      <Typography variant="body1"><strong>Status:</strong> {selectedPostRecovery.status}</Typography>
      <Typography variant="body1"><strong>Details:</strong> {selectedPostRecovery.details}</Typography>
    </Box>
  );

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>Post-Recovery Records</Typography>
      <Toolbar>
        <TextField
          value={searchTerm}
          onChange={handleSearch}
          placeholder="Search post-recovery records"
          variant="outlined"
          size="small"
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Toolbar>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : selectedPostRecovery ? (
        renderDetails()
      ) : (
        renderTable()
      )}
    </Container>
  );
};

export default UserPostRecovery;
